import api from "./apiService";

const consultarRelatorio = {
  postconsultarRelatorio: async (data) => {
    let res = await api.post("relatorio", data);
    return res.data;
  },
};

export default consultarRelatorio;
